import $ from "jquery";
import * as locationUtils from "../location";
import * as loggerUtils from "../logger";
import {Router} from './router';

const logger = loggerUtils.newLogger('Loader');

export class Loader {
	/** @var {Router} */
	_router = null;
	_onStart = $.Callbacks();
	_onStop = $.Callbacks();
	_onResponse = $.Callbacks();
	/** @var XMLHttpRequest */
	_xhr = null;

	apiUrl = null;

	/**
	 * @param {Router} router
	 */
	constructor(router) {
		this._router = router;
		router.onNavigate((navData) => {
			this._doRequest(navData);
		})
	}

	onStart(callback) {
		this._onStart.add(callback);
	}

	onStop(callback) {
		this._onStop.add(callback);
	}

	onResponse(callback) {
		this._onResponse.add(callback);
	}

	_doRequest(navData) {
		let {url, data} = navData;
		const {lastChange} = data || {};
		let partialLoad = false;

		if (lastChange) {
			const val = lastChange.page || lastChange.limit || lastChange.sort;
			partialLoad = val !== undefined && val !== null;
		}

		if (this.apiUrl) {
			let query = navData.query;
			query = locationUtils.appendQuery(query, {
				...navData.params,
				partial: partialLoad
			});
			url = this.apiUrl + '?' + query;
		} else if (partialLoad) {
			url = locationUtils.addQuery(url, {partial: true});
		}

		logger.log('do server request', url, navData);

		this._cancel();
		this._onStart.fire();
		this._xhr = $.ajax(url, {
			dataType: 'json',
			success: (data, status) => {
				logger.log('handle server response', status);
				this._onResponse.fire(data);
				this._onStop.fire(true, data);
			},
			error: (xhr, status, error) => {
				if (status !== 'abort') {
					logger.error('XHR error', status, error);
				}
				this._onStop.fire(false);
			}
		});
	}

	_cancel() {
		if (this._xhr && this._xhr.readyState !== 4) {
			this._xhr.abort();
			this._xhr = null;
		}
	}
}


// WEBPACK FOOTER //
// ./core/utils/nav/loader.js